import { DatePipe } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import {
  GcButtonComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-section-not-applicable-card',
  imports: [DatePipe, GcButtonComponent, GcTextComponent, IpoTranslatePipe],
  templateUrl: './section-not-applicable-card.component.html',
  styleUrl: './section-not-applicable-card.component.scss',
})
export class SectionNotApplicableCardComponent {
  comment = input<string | null>(null);
  updatedBy = input<string | null>(null);
  updatedAt = input<string | Date | null>(null);
  isSaving = input(false);

  reactivate = output<void>();

  readonly isLoading = computed<boolean>(() => this.isSaving());
}
